import { CountryField } from 'components/Fields/CountryField';
import CustomRadioGroup from 'components/CustomRadioGroup/CustomRadioGroup';
import { Heading } from 'components/Elements/Heading';
import { Separator } from 'components/Elements/Separator';
import { FileUploadField } from 'components/FileUpload/FileUploadField';
import DocStack from 'components/DocStack/DocStack';
import { ColorPickerField } from 'components/Fields/ColorPickerField';
import { CheckboxSet } from 'components/Fields/CheckboxSet';
import { CheckboxField } from 'components/Fields/CheckboxField';
import { SchoolSubjectsField } from 'components/Fields/SchoolSubjectsField';
import { Input } from 'components/Fields/Input';
import { Dropdown } from 'components/Fields/Dropdown';

/*
 * This is the field map used for non-Workflow forms only, there is another field map for Workflow fields
 *
 * @see resources/assets/js/forms/fieldComponentsMap.js
 */
export const fieldMap = {
	checkbox: CheckboxField,
	country: CountryField,
	dropdown: Dropdown,
	email: Input,
	password: Input,
	radiogroup: CustomRadioGroup,
	tel: Input,
	number: Input,
	text: Input,
	textarea: Input,
	separator: Separator,
	heading: Heading,
	file: FileUploadField,
	color: ColorPickerField,
	documents: DocStack,
	time: Input,
	checkboxset: CheckboxSet,
	schoolsubjects: SchoolSubjectsField,
};
